var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 26V9.27273H15.381V26H12.5714ZM14 6.48485C13.4524 6.48485 12.9802 6.31424 12.5833 5.97301C12.1944 5.63179 12 5.22159 12 4.74242C12 4.26326 12.1944 3.85306 12.5833 3.51184C12.9802 3.17061 13.4524 3 14 3C14.5476 3 15.0159 3.17061 15.4048 3.51184C15.8016 3.85306 16 4.26326 16 4.74242C16 5.22159 15.8016 5.63179 15.4048 5.97301C15.0159 6.31424 14.5476 6.48485 14 6.48485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfoIcon);
export default __webpack_public_path__ + "static/media/moreInfoIcon.b691f1982775d69c7a5a2c45d50d0445.svg";
export { ForwardRef as ReactComponent };